import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {environment} from '../../../environments/environment';

declare global {
    interface Window {
        _hsq: any;
    }
}

@Injectable({providedIn: 'root'})
export class HubspotService {

    private renderer: Renderer2;

    constructor(private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    /**
     * Init the hubspot script
     * @param forceRun is used for init hubspot outside prod env
     */
    public init(forceRun = false) {
        if (forceRun || environment.production) {
            const script = this.renderer.createElement('script');
            script.type = 'text/javascript';
            script.id = 'hs-script-loader';
            script.async = true;
            script.defer = true;
            script.src = '//js-eu1.hs-scripts.com/139699684.js';
            this.renderer.appendChild(document.body, script);
        }
    }

    public trackPage(url: string) {
        const hsq = window._hsq = window._hsq || [];
        hsq.push(['setPath', url]);
        hsq.push(['trackPageView']);
    }

    public stop() {
        const hsq = window._hsq = window._hsq || [];
        hsq.push(['revokeCookieConsent']);
        hsq.push(['addPrivacyConsentListener'], {allowed: false});
        const scriptToRemove = document.getElementById('hs-script-loader');
        if (scriptToRemove) {
            scriptToRemove.remove();
        }
    }

    public start() {
        const hsq = window._hsq = window._hsq || [];
        hsq.push(['addPrivacyConsentListener'], {allowed: true});
        this.init();
    }
}

